export default __webpack_public_path__ + "static/media/prima-nota.24ab10c0.svg";